module.exports = __webpack_public_path__ + "img/lecture_next_btn.e20161cd.svg";